import * as React from 'react'
import {Toaster} from 'react-hot-toast'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import {Hydrate} from 'react-query/hydration'

import {ThemeProvider} from './theme-context'

/**
 * A collection of providers for app and site
 */
function Providers({
  dehydratedState,
  children,
}: {
  dehydratedState: unknown
  children: React.ReactNode
}) {
  const queryClientRef = React.useRef<QueryClient>()
  if (!queryClientRef.current) {
    // LATER: configure options
    queryClientRef.current = new QueryClient()
  }
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClientRef.current}>
        <Hydrate state={dehydratedState}>
          {children}
          <Toaster />
          <ReactQueryDevtools position="bottom-right" />
        </Hydrate>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export {Providers}
